import { Typography } from '@progress/kendo-react-common';
import React, { CSSProperties, ReactNode, useEffect, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { ContentVersion } from '../../../generated/graphql';
import styles from './DownloadDialog.module.css';

type DownloadDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
    request: ContentVersion | undefined;
};

const DownloadDialog = (props: DownloadDialogProps) => {
    const { style, visible, request, onClose } = props;
    const [isDownloading, setIsDownloading] = useState(false);

    const downloadHandler = () => {
        const downloadUrl = request?.attachment?.downloadUrl;
        if (!downloadUrl) return;
        setIsDownloading(true);
        // The attachment is stored as raw bytes in blob storage and downloadUrl is a
        // pre-signed SAS GET URL. Fetch it as a binary blob and download via an object URL.
        fetch(downloadUrl)
            .then((res) => {
                if (!res.ok) throw new Error(`Download failed: ${res.statusText}`);
                return res.blob();
            })
            .then((blob) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${request?.name ?? 'download'}${request?.attachment?.extension ?? ''}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
                setIsDownloading(false);
                onClose();
            })
            .catch(() => {
                setIsDownloading(false);
                onClose();
            });
    };

    useEffect(() => {
        downloadHandler();
    }, []);


    return (
        <DialogBase
            title=" "
            type="OkCancel"
            visible={visible}
            onClose={onClose}
            isLoading={isDownloading}
            className={styles.DownloadDialog}
            style={style}
            data-testid="DownloadDialog">
            <Typography.p>Downloading...</Typography.p>
        </DialogBase>
    );
};

export default DownloadDialog;
